import { Host, h } from "@stencil/core";
export class CoreBreadcrumb {
    constructor() {
        this.breadcrumbInit = () => {
            const breadcrumb = this.getBreadcrumb();
            if (breadcrumb.length > 1) {
                breadcrumb.forEach((item, index) => {
                    item.setAttribute('variant', 'secondary');
                    item.setAttribute('size', 'small');
                    if (index + 1 < breadcrumb.length) {
                        // Items with links
                        const icon = document.createElement('core-icon');
                        icon.setAttribute('name', 'chevron_right-outline');
                        icon.setAttribute('size', 'number-size-icon-medium');
                        icon.setAttribute('fill', 'color-neutral-content-medium');
                        icon.setAttribute('class', 'core-breadcrumb-item-separator');
                        icon.style.setProperty('padding', 'var(--number-spacing-none) var(--number-spacing-4xsmall)');
                        item.parentElement.append(icon);
                    }
                    else {
                        // Last item should not be a link
                        const span = document.createElement('span');
                        span.setAttribute('class', 'current-item typography-body-small-bold');
                        span.setAttribute('aria-current', 'page');
                        span.textContent = item.querySelector('a') ? item.querySelector('a').textContent : item.getAttribute('label');
                        item.parentElement.replaceChild(span, item);
                    }
                });
            }
        };
        this.getBreadcrumb = () => {
            return Array.from(this.element.querySelectorAll('core-link'));
        };
    }
    componentWillLoad() {
        this.breadcrumbInit();
    }
    render() {
        return (h(Host, { key: '8b9b1386ffdfbd4b8d9b77ee9794e18f1ed876ed' }, h("nav", { key: '225f3ef56251a87797147521207239fcb3b37f99', class: "core-breadcrumb", "aria-label": "breacrumb" }, h("ol", { key: 'f34d74d5f5a98959528caf819898f96697e3fe12', class: "core-breadcrumb-list" }, h("slot", { key: '514a82fd6e35f192d096e44e85bf007e207ef784' })))));
    }
    static get is() { return "core-breadcrumb"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-breadcrumb.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-breadcrumb.css"]
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=core-breadcrumb.js.map
